
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as d2FzbTpqcy1zdHJpbmc from './KmpAppBase-webApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToBoolean' : (ref) => Boolean(ref),
    'kotlin.wasm.internal.doubleToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_0' : (f, trampoline) => getCachedJsObject(f, () => trampoline(f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.io.printError' : (error) => console.error(error),
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.JsBoolean_$external_class_instanceof' : (x) => typeof x === 'boolean',
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.Promise_$external_fun' : (p0) => new Promise(p0),
    'kotlin.js.__callJsClosure_((Js?)->Unit)' : (f, p0) => f(p0),
    'kotlin.js.__callJsClosure_((Js)->Unit)' : (f, p0) => f(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_2' : (f, trampoline) => getCachedJsObject(f, (p0, p1) => trampoline(f, p0, p1)),
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_1' : (f, trampoline) => getCachedJsObject(f, (p0) => trampoline(f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.js.Promise_$external_class_instanceof' : (x) => x instanceof Promise,
    'kotlin.js.Promise_$external_class_get' : () => Promise,
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.promiseSetDeferred' : (promise, deferred) => promise.deferred = deferred,
    'kotlinx.coroutines.promiseSetDeferred_1' : (promise, deferred) => promise.deferred = deferred,
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.ArrayBuffer_$external_class_instanceof' : (x) => x instanceof ArrayBuffer,
    'org.khronos.webgl.ArrayBuffer_$external_class_get' : () => ArrayBuffer,
    'org.khronos.webgl.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
    'org.khronos.webgl.Int8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter_1' : (_this) => _this.byteLength,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.fontSize_$external_prop_getter' : (_this) => _this.fontSize,
    'org.w3c.dom.css.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
    'org.w3c.dom.events.DOM_DELTA_PIXEL_$external_prop_getter' : (_this) => _this.DOM_DELTA_PIXEL,
    'org.w3c.dom.events.DOM_DELTA_LINE_$external_prop_getter' : (_this) => _this.DOM_DELTA_LINE,
    'org.w3c.dom.events.DOM_DELTA_PAGE_$external_prop_getter' : (_this) => _this.DOM_DELTA_PAGE,
    'org.w3c.dom.events.Companion_$external_object_getInstance' : () => WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_instanceof' : (x) => x instanceof FocusEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_get' : () => FocusEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.history_$external_prop_getter' : (_this) => _this.history,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.getComputedStyle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getComputedStyle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.message_$external_prop_getter' : (_this) => _this.message,
    'org.w3c.dom.ErrorEvent_$external_class_instanceof' : (x) => x instanceof ErrorEvent,
    'org.w3c.dom.ErrorEvent_$external_class_get' : () => ErrorEvent,
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'org.w3c.dom.search_$external_prop_getter' : (_this) => _this.search,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.title_$external_prop_setter' : (_this, v) => _this.title = v,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.classList_$external_prop_getter' : (_this) => _this.classList,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.add_$external_fun' : (_this, p0) => _this.add(...p0),
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.protocol_$external_prop_getter_1' : (_this) => _this.protocol,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.OPEN_$external_prop_getter' : (_this) => _this.OPEN,
    'org.w3c.dom.Companion_$external_object_getInstance' : () => WebSocket,
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.Storage_$external_class_instanceof' : (x) => x instanceof Storage,
    'org.w3c.dom.Storage_$external_class_get' : () => Storage,
    'org.w3c.dom.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.StorageEvent_$external_class_instanceof' : (x) => x instanceof StorageEvent,
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.oncancel_$external_prop_setter' : (_this, v) => _this.oncancel = v,
    'org.w3c.dom.onchange_$external_prop_setter' : (_this, v) => _this.onchange = v,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.back_$external_fun' : (_this, ) => _this.back(),
    'org.w3c.dom.pushState_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.pushState(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.replaceState_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.replaceState(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance_2' : () => ({}),
    'org.w3c.dom.accept_$external_prop_setter' : (_this, v) => _this.accept = v,
    'org.w3c.dom.files_$external_prop_getter' : (_this) => _this.files,
    'org.w3c.dom.multiple_$external_prop_setter' : (_this, v) => _this.multiple = v,
    'org.w3c.dom.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'org.w3c.dom.HTMLInputElement_$external_class_instanceof' : (x) => x instanceof HTMLInputElement,
    'org.w3c.dom.HTMLInputElement_$external_class_get' : () => HTMLInputElement,
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_instanceof' : (x) => x instanceof PointerEvent,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_get' : () => PointerEvent,
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.arrayBuffer_$external_fun' : (_this, ) => _this.arrayBuffer(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.Response_$external_class_instanceof' : (x) => x instanceof Response,
    'org.w3c.fetch.Response_$external_class_get' : () => Response,
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.files.File_$external_fun' : (p0, p1, p2, isDefault0) => new File(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.files.name_$external_prop_getter' : (_this) => _this.name,
    'org.w3c.files.FileReader_$external_fun' : () => new FileReader(),
    'org.w3c.files.result_$external_prop_getter' : (_this) => _this.result,
    'org.w3c.files.onload_$external_prop_setter' : (_this, v) => _this.onload = v,
    'org.w3c.files.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
    'org.w3c.files.readAsArrayBuffer_$external_fun' : (_this, p0) => _this.readAsArrayBuffer(p0),
    'org.w3c.files.slice_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.slice(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'kotlinx.browser.sessionStorage_$external_prop_getter' : () => sessionStorage,
    'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.defaultFetchInit_js_code' : () => ({}),
    'org.jetbrains.skiko.jsCatch' : function (f) { try { f(); } catch (e) { return e;}; return null; },
    'org.jetbrains.skiko.jsThrow' : (e) => { throw e; },
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._script_$external_prop_getter' : (_this) => _this.script,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isVibrationSupported' : () => 
            typeof window !== 'undefined' &&
            window.navigator != null &&
            typeof window.navigator.vibrate === 'function'
        ,
    'androidx.compose.ui.platform.vibrate' : (pattern) => { window.navigator.vibrate(pattern) },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.isFullWakeLockApiSupported' : () => Boolean(
            window.navigator.wakeLock && 
            typeof(WakeLockSentinel) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isTouchEvent' : (event) => event.pointerType === 'touch',
    'androidx.compose.ui.window.releasePointerCapture' : (target, pointerId) => { try { target.releasePointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.gestures.legacyWheelDeltaX' : (event) => (event.wheelDeltaX == null) ? NaN : event.wheelDeltaX,
    'androidx.compose.foundation.gestures.legacyWheelDeltaY' : (event) => (event.wheelDeltaY == null) ? NaN : event.wheelDeltaY,
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.script_$external_prop_getter' : (_this) => _this.script,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.jsFetchWithSignal' : (url, signal) => window.fetch(url, { signal }),
    'org.jetbrains.compose.resources.AbortController_$external_fun' : () => new AbortController(),
    'org.jetbrains.compose.resources.signal_$external_prop_getter' : (_this) => _this.signal,
    'org.jetbrains.compose.resources.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.jetbrains.compose.resources.isWasmExportsAvailable' : () => typeof wasmExports !== 'undefined',
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'com.vervaintech.utils.navigatorOnLine' : () => navigator.onLine,
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.material3.internal.getFirstDayOfWeek' : (locale) => { try { 
               return new Intl.Locale(locale).weekInfo.firstDay; 
            } catch (error) { 
               return -1; 
          }},
    'androidx.compose.material3.internal.getIs24HourFormat' : (localeTag) => {
                var locale = new Intl.Locale(localeTag);
                // Check for the hourCycles property first
                if (locale.hourCycles) {
                    return locale.hourCycles.includes('h23') || locale.hourCycles.includes('h24') ? 1 : 0;
                }

                // Fallback to hourCycle property
                if (locale.hourCycle) {
                    return locale.hourCycle === 'h23' || locale.hourCycle === 'h24' ? 1 : 0;
                }
                return -1;
            },
    'androidx.compose.material3.internal.emptyLocaleOptions' : () => new Object(),
    'androidx.compose.material3.internal.Date_$external_fun' : (p0) => new Date(p0),
    'androidx.compose.material3.internal.Date_$external_fun_1' : (p0, p1, p2) => new Date(p0, p1, p2),
    'androidx.compose.material3.internal.getDay_$external_fun' : (_this, ) => _this.getDay(),
    'androidx.compose.material3.internal.toLocaleDateString_$external_fun' : (_this, p0, p1, isDefault0) => _this.toLocaleDateString(p0, isDefault0 ? undefined : p1, ),
    'androidx.compose.material3.internal.now_$external_fun' : (_this, ) => _this.now(),
    'androidx.compose.material3.internal.Companion_$external_object_getInstance' : () => Date,
    'androidx.compose.material3.internal.weekday_$external_prop_setter' : (_this, v) => _this.weekday = v,
    'androidx.compose.material3.internal.year_$external_prop_setter' : (_this, v) => _this.year = v,
    'androidx.compose.material3.internal.month_$external_prop_setter' : (_this, v) => _this.month = v,
    'androidx.compose.material3.internal.day_$external_prop_setter' : (_this, v) => _this.day = v,
    'androidx.compose.material3.internal.hour_$external_prop_setter' : (_this, v) => _this.hour = v,
    'androidx.compose.material3.internal.minute_$external_prop_setter' : (_this, v) => _this.minute = v,
    'androidx.compose.material3.internal.second_$external_prop_setter' : (_this, v) => _this.second = v,
    'androidx.compose.material3.internal.Date_$external_class_instanceof' : (x) => x instanceof Date,
    'androidx.compose.material3.internal.Date_$external_class_get' : () => Date,
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.getPlatformName' : 
        () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
    ,
    'kotlinx.io.node.loadBuffer' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:buffer') : null),
    'kotlinx.io.node.loadOs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:os') : null),
    'kotlinx.io.node.loadPath' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:path') : null),
    'kotlinx.io.node.loadFs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:fs') : null),
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.util.date.UTC_$external_fun' : (_this, p0, p1, p2, p3, p4, p5) => _this.UTC(p0, p1, p2, p3, p4, p5),
    'io.ktor.util.date.Companion_$external_object_getInstance' : () => Date,
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'androidx.compose.material3.adaptive.layout.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.adaptive.layout.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.adaptive.layout.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'com.vervaintech.components.utils.intlCurrencySymbolOrEmpty' : (code) => {
        try {
            var parts = new Intl.NumberFormat('en', {style: 'currency', currency: code})
                .formatToParts(1);
            for (var i = 0; i < parts.length; i++) {
                if (parts[i].type === 'currency') return parts[i].value;
            }
            return '';
        } catch (e) {
            return '';
        }
    },
    'com.vervaintech.components.utils.intlCurrencyFractionDigits' : (code) => {
        try {
            var opts = new Intl.NumberFormat('en', {style: 'currency', currency: code})
                .resolvedOptions();
            return opts.maximumFractionDigits;
        } catch (e) {
            return -1;
        }
    },
    'com.vervaintech.firebase.web.jsIsSupported' : (api) => api.isSupported(),
    'com.vervaintech.firebase.web.jsNewObject' : () => ({}),
    'com.vervaintech.firebase.web.jsSetString' : (o, k, v) => { o[k] = v },
    'com.vervaintech.firebase.web.jsSetBoolean' : (o, k, v) => { o[k] = v },
    'com.vervaintech.firebase.web.jsSetNumber' : (o, k, v) => { o[k] = v },
    'com.vervaintech.firebase.web.jsLogEvent' : (api, name, params) => { api.logEvent(api.getAnalytics(api.getApp()), name, params) },
    'com.vervaintech.firebase.web.jsConsoleWarnAnalytics' : (message) => { console.warn(message) },
    'com.vervaintech.firebase.web.jsLoadAnalyticsApi' : () => 
        Promise.all([
            import('firebase/analytics'),
            import('firebase/app')
        ]).then(function (m) {
            var g = m[0], a = m[1];
            return {
                getAnalytics: g.getAnalytics, logEvent: g.logEvent, isSupported: g.isSupported,
                getApp: a.getApp
            };
        })
        ,
    'com.vervaintech.firebase.web.jsRedirectPending' : () => (function () { try { return sessionStorage.getItem('prompzy.googleRedirect') === '1'; } catch (_) { return false; } })(),
    'com.vervaintech.firebase.web.jsLogRedirectReturn' : (stage, detail) => console.error('[auth-redirect] ' + stage + ': ' + detail + ' | origin=' + location.origin + ' hasFocus=' + document.hasFocus() + ' ua=' + navigator.userAgent),
    'com.vervaintech.firebase.web.jsGetRedirectResult' : (api, auth) => api.getRedirectResult(auth),
    'com.vervaintech.firebase.web.jsDescribeCurrentUser' : (auth) => (function () { var u = auth.currentUser; if (!u) return 'none'; return u.uid + ' anonymous=' + u.isAnonymous + ' providers=' + (u.providerData || []).map(function (p) { return p.providerId; }).join(','); })(),
    'com.vervaintech.firebase.web.jsHasSignedInGoogleUser' : (auth) => (function () { var u = auth.currentUser; return !!(u && !u.isAnonymous && (u.providerData || []).some(function (p) { return p.providerId === 'google.com'; })); })(),
    'com.vervaintech.firebase.web.jsGoogleIdTokenFromResult' : (api, result) => (function () { var c = api.GoogleAuthProvider.credentialFromResult(result); return (c && c.idToken) ? c.idToken : null; })(),
    'com.vervaintech.firebase.web.jsGoogleAccessTokenFromResult' : (api, result) => (function () { var c = api.GoogleAuthProvider.credentialFromResult(result); return (c && c.accessToken) ? c.accessToken : null; })(),
    'com.vervaintech.firebase.web.jsErrorCode' : (e) => (e && (e.code || e.name)) ? String(e.code || e.name) : 'unknown',
    'com.vervaintech.firebase.web.jsErrorMessage' : (e) => (e && e.message) ? String(e.message) : String(e),
    'com.vervaintech.firebase.web.jsSetRedirectPending' : (pending) => (function () { try { if (pending) sessionStorage.setItem('prompzy.googleRedirect', '1'); else sessionStorage.removeItem('prompzy.googleRedirect'); } catch (_) {} })(),
    'com.vervaintech.firebase.web.jsCurrentUser' : (auth) => auth.currentUser ?? null,
    'com.vervaintech.firebase.web.jsUid' : (user) => user.uid,
    'com.vervaintech.firebase.web.jsOnAuthStateChanged' : (api, auth, onChange) => api.onAuthStateChanged(auth, onChange),
    'com.vervaintech.firebase.web.jsAsUserOrNull' : (value) => value ?? null,
    'com.vervaintech.firebase.web.jsInvokeUnsubscribe' : (unsubscribe) => { unsubscribe() },
    'com.vervaintech.firebase.web.jsSignInAnonymously' : (api, auth) => api.signInAnonymously(auth),
    'com.vervaintech.firebase.web.jsIsAnonymous' : (user) => user.isAnonymous === true,
    'com.vervaintech.firebase.web.jsOnIdTokenChanged' : (api, auth, onChange) => api.onIdTokenChanged(auth, onChange),
    'com.vervaintech.firebase.web.jsLinkWithCredential' : (api, user, credential) => api.linkWithCredential(user, credential),
    'com.vervaintech.firebase.web.jsEmailCredential' : (api, email, password) => api.EmailAuthProvider.credential(email, password),
    'com.vervaintech.firebase.web.jsCreateUser' : (api, auth, email, password) => api.createUserWithEmailAndPassword(auth, email, password),
    'com.vervaintech.firebase.web.jsCredentialUser' : (credential) => credential.user ?? null,
    'com.vervaintech.firebase.web.jsSignInEmail' : (api, auth, email, password) => api.signInWithEmailAndPassword(auth, email, password),
    'com.vervaintech.firebase.web.jsUserEmail' : (user) => user.email ?? null,
    'com.vervaintech.firebase.web.jsUserDisplayName' : (user) => user.displayName ?? null,
    'com.vervaintech.firebase.web.jsGoogleCredential' : (api, idToken, accessToken) => api.GoogleAuthProvider.credential(idToken, accessToken),
    'com.vervaintech.firebase.web.jsSignInCredential' : (api, auth, credential) => api.signInWithCredential(auth, credential),
    'com.vervaintech.firebase.web.jsCurrentProviderIds' : (auth) => (auth.currentUser ? auth.currentUser.providerData.map(function (p) { return p.providerId; }).join(',') : ''),
    'com.vervaintech.firebase.web.jsSignOut' : (api, auth) => api.signOut(auth),
    'com.vervaintech.firebase.web.jsSendPasswordReset' : (api, auth, email) => api.sendPasswordResetEmail(auth, email),
    'com.vervaintech.firebase.web.jsVerifyPasswordResetCode' : (api, auth, oobCode) => api.verifyPasswordResetCode(auth, oobCode),
    'com.vervaintech.firebase.web.jsConfirmPasswordReset' : (api, auth, oobCode, newPassword) => api.confirmPasswordReset(auth, oobCode, newPassword),
    'com.vervaintech.firebase.web.jsApplyActionCode' : (api, auth, oobCode) => api.applyActionCode(auth, oobCode),
    'com.vervaintech.firebase.web.jsGetIdToken' : (user, forceRefresh) => user.getIdToken(forceRefresh),
    'com.vervaintech.firebase.web.jsGetIdTokenResult' : (user, forceRefresh) => user.getIdTokenResult(forceRefresh),
    'com.vervaintech.firebase.web.jsIdTokenResultClaimBool' : (result, key) => result.claims[key] === true,
    'com.vervaintech.firebase.web.jsNewGoogleProvider' : (api, prompt) => (function () { var p = new api.GoogleAuthProvider(); p.setCustomParameters({ prompt: prompt }); return p; })(),
    'com.vervaintech.firebase.web.jsPrefersRedirectSignIn' : (authDomain) => 
        (function () {
            try { if (sessionStorage.getItem('prompzy.forceRedirect') === '1') return true; } catch (_) {}
            if (/[?&]signinRedirect=1(&|$)/.test(location.search)) {
                try { sessionStorage.setItem('prompzy.forceRedirect', '1'); } catch (_) {}
                return true;
            }
            var ua = navigator.userAgent || '';
            var touchBrowser = /iPhone|iPad|iPod|Android/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
            if (!touchBrowser) return false;
            // Same ORIGIN only: the redirect state lives per origin, so an alias
            // host (apex, *.web.app) of the auth domain would come back empty.
            return location.hostname === authDomain;
        })()
        ,
    'com.vervaintech.firebase.web.jsSignInWithRedirect' : (api, auth, provider) => api.signInWithRedirect(auth, provider),
    'com.vervaintech.firebase.web.jsSignInWithPopup' : (api, auth, provider) => api.signInWithPopup(auth, provider),
    'com.vervaintech.firebase.web.jsAuthDomain' : (auth) => (auth && auth.config && auth.config.authDomain) ? String(auth.config.authDomain) : '',
    'com.vervaintech.firebase.web.jsGetAuth' : (api, app) => api.getAuth(app),
    'com.vervaintech.firebase.web.jsCollection' : (api, firestore, path) => api.collection(firestore, path),
    'com.vervaintech.firebase.web.jsApplyQuery' : (api, base, constraints) => api.query.apply(null, [base].concat(Array.prototype.slice.call(constraints))),
    'com.vervaintech.firebase.web.jsGetDocs' : (api, query) => api.getDocs(query),
    'com.vervaintech.firebase.web.jsOnSnapshotQuery' : (api, query, onNext, onError) => api.onSnapshot(query, onNext, onError),
    'com.vervaintech.firebase.web.jsInvokeUnsubscribeQuery' : (unsubscribe) => { unsubscribe() },
    'com.vervaintech.firebase.web.jsWhere' : (api, field, opStr, value) => api.where(field, opStr, value),
    'com.vervaintech.firebase.web.jsOrderBy' : (api, field, directionStr) => api.orderBy(field, directionStr),
    'com.vervaintech.firebase.web.jsStartAt' : (api, value) => api.startAt(value),
    'com.vervaintech.firebase.web.jsEndAt' : (api, value) => api.endAt(value),
    'com.vervaintech.firebase.web.jsLimit' : (api, count) => api.limit(count),
    'com.vervaintech.firebase.web.jsQuerySnapshotDocs' : (snapshot) => snapshot.docs,
    'com.vervaintech.firebase.web.jsRunTransaction' : (api, db, updateFn) => api.runTransaction(db, updateFn),
    'com.vervaintech.firebase.web.jsTxGet' : (tx, reference) => tx.get(reference),
    'com.vervaintech.firebase.web.jsTxSet' : (tx, reference, data) => { tx.set(reference, data) },
    'com.vervaintech.firebase.web.jsTxUpdate' : (tx, reference, data) => { tx.update(reference, data) },
    'com.vervaintech.firebase.web.jsTxDelete' : (tx, reference) => { tx.delete(reference) },
    'com.vervaintech.firebase.web.jsErrorString' : (error) => String(error && error.message ? error.message : error),
    'com.vervaintech.firebase.web.jsGetDoc' : (api, reference) => api.getDoc(reference),
    'com.vervaintech.firebase.web.jsExists' : (snapshot) => snapshot.exists(),
    'com.vervaintech.firebase.web.jsFirestoreDataToJson' : (snapshot) => 
        (function () {
            function norm(v) {
                if (v === null || v === undefined) return null;
                if (typeof v === 'object') {
                    if (typeof v.toMillis === 'function') return v.toMillis();
                    if (Array.isArray(v)) return v.map(norm);
                    var o = {};
                    for (var k in v) { if (Object.prototype.hasOwnProperty.call(v, k)) o[k] = norm(v[k]); }
                    return o;
                }
                return v;
            }
            var data = snapshot.data();
            return JSON.stringify(data === undefined ? {} : norm(data));
        })()
        ,
    'com.vervaintech.firebase.web.jsOnSnapshotDoc' : (api, reference, onNext, onError) => api.onSnapshot(reference, onNext, onError),
    'com.vervaintech.firebase.web.jsInvokeUnsubscribe_1' : (unsubscribe) => { unsubscribe() },
    'com.vervaintech.firebase.web.jsFromCache' : (snapshot) => snapshot.metadata.fromCache === true,
    'com.vervaintech.firebase.web.jsDoc' : (api, firestore, path) => api.doc(firestore, path),
    'com.vervaintech.firebase.web.jsGetFirestore' : (api, app) => api.getFirestore(app),
    'com.vervaintech.firebase.web.jsonToJsObject' : (json) => JSON.parse(json),
    'com.vervaintech.firebase.web.jsAnyToJson' : (value) => JSON.stringify(value === undefined ? null : value),
    'com.vervaintech.firebase.web.jsSetDoc' : (api, reference, data) => api.setDoc(reference, data),
    'com.vervaintech.firebase.web.jsUpdateDoc' : (api, reference, data) => api.updateDoc(reference, data),
    'com.vervaintech.firebase.web.jsDeleteDoc' : (api, reference) => api.deleteDoc(reference),
    'com.vervaintech.firebase.web.jsErrorCode_1' : (error) => (error && error.code) ? String(error.code) : '',
    'com.vervaintech.firebase.web.jsInvokeCallable' : (callable, data) => callable(data),
    'com.vervaintech.firebase.web.jsHttpsCallable' : (api, functions, name) => api.httpsCallable(functions, name),
    'com.vervaintech.firebase.web.jsCallableResultData' : (result) => result.data ?? null,
    'com.vervaintech.firebase.web.jsGetFunctions' : (api, app, region) => api.getFunctions(app, region),
    'com.vervaintech.firebase.web.jsLoadFirebaseApi' : () => 
        Promise.all([
            import('firebase/app'),
            import('firebase/firestore'),
            import('firebase/auth'),
            import('firebase/functions'),
            import('firebase/storage'),
            import('firebase/app-check')
        ]).then(function (m) {
            var a = m[0], f = m[1], u = m[2], n = m[3], s = m[4], c = m[5];
            return {
                initializeApp: a.initializeApp,
                getFirestore: f.getFirestore, doc: f.doc, getDoc: f.getDoc, onSnapshot: f.onSnapshot,
                collection: f.collection, query: f.query, where: f.where, orderBy: f.orderBy, limit: f.limit,
                startAt: f.startAt, endAt: f.endAt, runTransaction: f.runTransaction,
                getDocs: f.getDocs, setDoc: f.setDoc, updateDoc: f.updateDoc, addDoc: f.addDoc,
                deleteDoc: f.deleteDoc, serverTimestamp: f.serverTimestamp,
                getAuth: u.getAuth, signInAnonymously: u.signInAnonymously, onAuthStateChanged: u.onAuthStateChanged, onIdTokenChanged: u.onIdTokenChanged,
                createUserWithEmailAndPassword: u.createUserWithEmailAndPassword,
                signInWithEmailAndPassword: u.signInWithEmailAndPassword, signInWithCredential: u.signInWithCredential,
                signOut: u.signOut, sendPasswordResetEmail: u.sendPasswordResetEmail, linkWithCredential: u.linkWithCredential,
                confirmPasswordReset: u.confirmPasswordReset, verifyPasswordResetCode: u.verifyPasswordResetCode,
                applyActionCode: u.applyActionCode,
                signInWithPopup: u.signInWithPopup, signInWithRedirect: u.signInWithRedirect, getRedirectResult: u.getRedirectResult,
                GoogleAuthProvider: u.GoogleAuthProvider, EmailAuthProvider: u.EmailAuthProvider,
                getFunctions: n.getFunctions, httpsCallable: n.httpsCallable,
                getStorage: s.getStorage, storageRef: s.ref, getDownloadURL: s.getDownloadURL,
                uploadBytes: s.uploadBytes, deleteObject: s.deleteObject,
                initializeAppCheck: c.initializeAppCheck, ReCaptchaEnterpriseProvider: c.ReCaptchaEnterpriseProvider,
                getAppCheckToken: c.getToken
            };
        })
        ,
    'com.vervaintech.firebase.web.jsNotificationPermissionState' : () => (typeof Notification === 'undefined' ? 'unsupported' : Notification.permission),
    'com.vervaintech.firebase.web.jsRequestNotificationPermission' : () => 
        (function () {
            if (typeof Notification === 'undefined') {
                return Promise.resolve('unsupported');
            }
            return Promise.resolve(Notification.requestPermission());
        })()
        ,
    'com.vervaintech.firebase.web.jsConsoleWarn' : (message) => { console.warn(message) },
    'com.vervaintech.firebase.web.jsNotificationPermissionGranted' : () => (typeof Notification !== 'undefined' && Notification.permission === 'granted'),
    'com.vervaintech.firebase.web.jsRegisterServiceWorker' : () => 
        (function () {
            if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
                return Promise.resolve(null);
            }
            // Relative path keeps the SW scope under the /app/ deploy subfolder.
            // §sw-active-race (2026-09-15, prompzy-test): register() resolves while
            // the worker is still INSTALLING on a first visit, and the SDK's
            // PushManager.subscribe then aborts with "no active Service Worker" —
            // the very first "Enable notifications" tap never produced a token.
            // Wait for the worker to be active before handing the registration on.
            return navigator.serviceWorker.register('firebase-messaging-sw.js', { scope: './' })
                .then(function (reg) {
                    if (reg.active) { return reg; }
                    return navigator.serviceWorker.ready.then(function () { return reg; });
                });
        })()
        ,
    'com.vervaintech.firebase.web.jsGetToken' : (api, vapidKey, swRegistration) => 
        (function () {
            var messaging = api.getMessaging(api.getApp());
            var opts = { vapidKey: vapidKey };
            if (swRegistration) { opts.serviceWorkerRegistration = swRegistration; }
            return api.getToken(messaging, opts);
        })()
        ,
    'com.vervaintech.firebase.web.jsLoadMessagingApi' : () => 
        Promise.all([
            import('firebase/messaging'),
            import('firebase/app')
        ]).then(function (m) {
            var g = m[0], a = m[1];
            return {
                getMessaging: g.getMessaging, getToken: g.getToken, onMessage: g.onMessage,
                getApp: a.getApp
            };
        })
        ,
    'com.vervaintech.firebase.web.jsNewUint8Array' : (size) => new Uint8Array(size),
    'com.vervaintech.firebase.web.jsSetByte' : (array, index, value) => { array[index] = value },
    'com.vervaintech.firebase.web.jsUploadBytes' : (api, storage, path, bytes) => api.uploadBytes(api.storageRef(storage, path), bytes),
    'com.vervaintech.firebase.web.jsToStringResult' : (value) => String(value),
    'com.vervaintech.firebase.web.jsGetDownloadUrl' : (api, storage, path) => api.getDownloadURL(api.storageRef(storage, path)),
    'com.vervaintech.firebase.web.jsDeleteObject' : (api, storage, path) => api.deleteObject(api.storageRef(storage, path)),
    'com.vervaintech.firebase.web.jsGetStorage' : (api, app) => api.getStorage(app),
    'com.vervaintech.firebase.web.jsRefreshAppCheckToken' : (api) => 
        {
            var appCheck = globalThis.__prompzyAppCheck;
            if (!appCheck) return Promise.resolve(false);
            return api.getAppCheckToken(appCheck, true)
                .then(function (result) { return !!(result && result.token); })
                .catch(function (error) {
                    console.warn('App Check refresh failed: ' + (error && error.message));
                    return false;
                });
        }
        ,
    'com.vervaintech.firebase.web.jsInitializeApp' : (api, options) => api.initializeApp(options),
    'com.vervaintech.firebase.web.firebaseOptions' : (apiKey, authDomain, projectId, appId, storageBucket, messagingSenderId, measurementId) => ({ apiKey: apiKey, authDomain: authDomain, projectId: projectId, appId: appId, storageBucket: storageBucket, messagingSenderId: messagingSenderId, measurementId: measurementId }),
    'com.vervaintech.firebase.web.jsInitializeAppCheck' : (api, app, siteKey) => 
        {
            // The App Check SDK only injects `enterprise.js?render=<siteKey>` when
            // `grecaptcha.enterprise` is absent. Firebase Auth loads the bare
            // `enterprise.js` first, so the SDK skipped its own load, the client
            // for OUR key never rendered, `execute(siteKey)` rejected, and every
            // token exchange went out empty (HTTP 400, then throttled for a
            // minute). We register the keyed script ourselves and only activate
            // App Check once it has loaded, so the very first token request
            // finds a rendered client. Firestore, Functions and Storage all
            // subscribe to the app-check-internal component lazily, so a
            // deferred activation is picked up by every later request.
            var activate = function () {
                // Kept for refreshAppCheckToken (a callable retry after a 401).
                globalThis.__prompzyAppCheck = api.initializeAppCheck(app, {
                    provider: new api.ReCaptchaEnterpriseProvider(siteKey),
                    isTokenAutoRefreshEnabled: true
                });
            };
            var src = 'https://www.google.com/recaptcha/enterprise.js?render=' + encodeURIComponent(siteKey);
            var existing = document.querySelector('script[src="' + src + '"]');
            if (existing) {
                activate();
            } else {
                var script = document.createElement('script');
                script.src = src;
                script.async = true;
                script.onload = activate;
                script.onerror = activate; // offline: let the SDK report its own typed failure
                document.head.appendChild(script);
            }
        }
        ,
    'com.vervaintech.payment.stripe.api.jsRemoveStripeOverlay' : () => { 
            {
                var el = document.getElementById('vervain-stripe-overlay');
                if (el) el.remove();
            }
             },
    'com.vervaintech.payment.stripe.api.jsPresentStripeSheet' : (publishableKey, clientSecret, customerId, ephemeralKey, apiVersion, country, countryOptions, amountMinor, currencyCode, onResult) => { 
            {
                var finish = function (status, message) {
                    if (finish.done) return;
                    finish.done = true;
                    // Resume the Kotlin continuation BEFORE touching the DOM — if the
                    // overlay removal ever throws, the checkout coroutine must still
                    // resume (a lost resume = infinite Compose spinner).
                    try { onResult(status, message || ''); } catch (e) { console.error('Stripe sheet onResult failed: ' + e); }
                    try {
                        var el = document.getElementById('vervain-stripe-overlay');
                        if (el) el.remove();
                    } catch (e) { /* overlay already gone */ }
                };

                var existing = document.getElementById('vervain-stripe-overlay');
                if (existing) existing.remove();

                window.__vervainStripeResult = function (status, message) { finish(status, message); };

                var frame = document.createElement('iframe');
                frame.id = 'vervain-stripe-overlay';
                // Delegate the Payment Request API to the sheet page — without this
                // Google Pay / Apple Pay are blocked inside the iframe.
                frame.setAttribute('allow', 'payment');
                var sizeFrame = function () {
                    var w = document.documentElement.clientWidth || window.innerWidth || 0;
                    var h = document.documentElement.clientHeight || window.innerHeight || 0;
                    frame.style.cssText = 'position:fixed;top:0;left:0;width:' + w + 'px;height:' + h + 'px;' +
                        'z-index:2147483647;border:0;margin:0;padding:0;background:transparent;';
                };
                sizeFrame();
                // Same-origin sibling of index.html — resolves under /app/ in prod
                // and / in local serving (the SPA never deepens the URL path).
                frame.src = new URL('stripe-sheet.html', document.baseURI).toString();
                frame.onload = function () {
                    frame.contentWindow.postMessage({
                        type: 'vervain-stripe-init',
                        publishableKey: String(publishableKey),
                        clientSecret: String(clientSecret),
                        customerId: String(customerId || ''),
                        ephemeralKey: String(ephemeralKey || ''),
                        apiVersion: String(apiVersion || ''),
                        country: String(country || 'GB'),
                        countryOptions: String(countryOptions),
                        amountMinor: Number(amountMinor),
                        currencyCode: String(currencyCode || 'GBP')
                    }, window.location.origin);
                };
                frame.onerror = function () { finish('failed', 'Payment sheet failed to load'); };
                // Append to <html>: an iframe ELEMENT outside <body> still renders
                // (Compose owns <body> and collapses foreign children to 0x0).
                document.documentElement.appendChild(frame);
                window.requestAnimationFrame(sizeFrame);
                window.addEventListener('resize', sizeFrame);
            }
             },
    'androidx.datastore.core.okio.getArrayBufferFromBlob' : (blob) => blob.arrayBuffer(),
    'androidx.datastore.core.okio.getInt8' : (array, index) => array[index],
    'androidx.datastore.core.okio.setInt8' : (array, index, value) => array[index] = value,
    'androidx.datastore.core.okio.getWasmOpfsRoot' : () => window.navigator.storage.getDirectory(),
    'androidx.datastore.core.okio.getWasmNavigator' : () => navigator,
    'androidx.datastore.core.okio.createWritable_$external_fun' : (_this, ) => _this.createWritable(),
    'androidx.datastore.core.okio.getFile_$external_fun' : (_this, ) => _this.getFile(),
    'androidx.datastore.core.okio.getFileHandle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getFileHandle(p0, isDefault0 ? undefined : p1, ),
    'androidx.datastore.core.okio.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.datastore.core.okio.close_$external_fun' : (_this, ) => _this.close(),
    'androidx.datastore.core.okio.request_$external_fun' : (_this, p0, p1) => _this.request(p0, p1),
    'androidx.datastore.core.okio.request_$external_fun_1' : (_this, p0, p1, p2) => _this.request(p0, p1, p2),
    'androidx.datastore.core.okio.locks_$external_prop_getter' : (_this) => _this.locks,
    'androidx.datastore.core.okio.createCreateOptions' : () => ({create: true}),
    'androidx.datastore.core.okio.BroadcastChannel_$external_fun' : (p0) => new BroadcastChannel(p0),
    'androidx.datastore.core.okio.postMessage_$external_fun' : (_this, p0) => _this.postMessage(p0),
    'androidx.datastore.core.okio.close_$external_fun_1' : (_this, ) => _this.close(),
    'androidx.datastore.core.okio.onmessage_$external_prop_setter' : (_this, v) => _this.onmessage = v,
    'androidx.datastore.core.okio.tryLockOptions' : () => ({mode: 'exclusive', ifAvailable: true}),
    'com.vervaintech.roomdatabase.database.jsInitSqlite3' : () => import('@sqlite.org/sqlite-wasm').then(function(m){ return m.default(); }),
    'com.vervaintech.roomdatabase.database.jsInstallSahPool' : (sqlite3) => sqlite3.installOpfsSAHPoolVfs({}),
    'com.vervaintech.roomdatabase.database.jsOpenDb' : (poolUtil, fileName) => new poolUtil.OpfsSAHPoolDb(fileName),
    'com.vervaintech.roomdatabase.database.jsConsoleWarn' : (message) => { console.warn(message) },
    'com.vervaintech.roomdatabase.database.jsDbIsOpen' : (db) => db.isOpen(),
    'com.vervaintech.roomdatabase.database.jsOpenMemoryDb' : (sqlite3) => new sqlite3.oo1.DB(),
    'com.vervaintech.roomdatabase.database.jsDeleteOpfsFile' : (name) => 
        (function () {
            try {
                if (!(navigator.storage && navigator.storage.getDirectory)) return Promise.resolve(null);
                return navigator.storage.getDirectory()
                    .then(function (dir) { return dir.removeEntry(name); })
                    .then(function () { return null; })
                    .catch(function () { return null; });
            } catch (e) { return Promise.resolve(null); }
        })()
        ,
    'com.vervaintech.roomdatabase.database.jsReadOpfsSnapshot' : (name) => 
        (function () {
            try {
                if (!(navigator.storage && navigator.storage.getDirectory)) return Promise.resolve(null);
                var read = navigator.storage.getDirectory()
                    .then(function (dir) { return dir.getFileHandle(name); })
                    .then(function (handle) { return handle.getFile(); })
                    .then(function (file) { return file.arrayBuffer(); })
                    .then(function (buffer) { return new Uint8Array(buffer); });
                // Some embedded engines leave getDirectory() PENDING forever —
                // never block app boot on the snapshot (cold cache is fine).
                var timeout = new Promise(function (resolve) { setTimeout(function () { resolve(null); }, 3000); });
                return Promise.race([read, timeout]).catch(function () { return null; });
            } catch (e) { return Promise.resolve(null); }
        })()
        ,
    'com.vervaintech.roomdatabase.database.jsDeserializeInto' : (sqlite3, db, bytes) => 
        (function () {
            try {
                var p = sqlite3.wasm.allocFromTypedArray(bytes);
                var rc = sqlite3.capi.sqlite3_deserialize(
                    db.pointer, 'main', p, bytes.length, bytes.length,
                    sqlite3.capi.SQLITE_DESERIALIZE_FREEONCLOSE | sqlite3.capi.SQLITE_DESERIALIZE_RESIZEABLE);
                return rc === 0;
            } catch (e) { console.warn('cache snapshot restore failed: ' + e); return false; }
        })()
        ,
    'com.vervaintech.roomdatabase.database.jsInstallVisibilityFlush' : () => { 
            {
                if (!globalThis.__vervainCacheFlushInstalled) {
                    globalThis.__vervainCacheFlushInstalled = true;
                    var flush = function () {
                        if (globalThis.__vervainCachePersistTimer) {
                            clearTimeout(globalThis.__vervainCachePersistTimer);
                            globalThis.__vervainCachePersist();
                        }
                    };
                    document.addEventListener('visibilitychange', function () {
                        if (document.visibilityState === 'hidden') flush();
                    });
                    window.addEventListener('pagehide', flush);
                }
            }
             },
    'com.vervaintech.roomdatabase.database.jsDbInTransaction' : (sqlite3, db) => sqlite3.capi.sqlite3_get_autocommit(db.pointer) === 0,
    'com.vervaintech.roomdatabase.database.jsConsoleError' : (message) => { console.error(message) },
    'com.vervaintech.roomdatabase.database.jsSchedulePersist' : (sqlite3, db, name, delayMs) => { 
            {
                var g = globalThis;
                if (g.__vervainCachePersistTimer) { clearTimeout(g.__vervainCachePersistTimer); }
                g.__vervainCachePersist = function () {
                    g.__vervainCachePersistTimer = null;
                    try {
                        var bytes = sqlite3.capi.sqlite3_js_db_export(db.pointer);
                        navigator.storage.getDirectory()
                            .then(function (dir) { return dir.getFileHandle(name, { create: true }); })
                            .then(function (handle) { return handle.createWritable(); })
                            .then(function (w) { return w.write(bytes).then(function () { return w.close(); }); })
                            .catch(function (e) { console.warn('cache snapshot save failed: ' + e); });
                    } catch (e) { console.warn('cache snapshot export failed: ' + e); }
                };
                g.__vervainCachePersistTimer = setTimeout(g.__vervainCachePersist, delayMs);
            }
             },
    'com.vervaintech.roomdatabase.database.jsDbPrepare' : (db, sql) => db.prepare(sql),
    'com.vervaintech.roomdatabase.database.jsDbClose' : (db) => { db.close() },
    'com.vervaintech.roomdatabase.database.jsBindDouble' : (stmt, index, value) => { stmt.bind(index, value) },
    'com.vervaintech.roomdatabase.database.jsBindText' : (stmt, index, value) => { stmt.bind(index, value) },
    'com.vervaintech.roomdatabase.database.jsBindNull' : (stmt, index) => { stmt.bind(index, null) },
    'com.vervaintech.roomdatabase.database.jsGetDouble' : (stmt, index) => Number(stmt.get(index)),
    'com.vervaintech.roomdatabase.database.jsGetText' : (stmt, index) => String(stmt.get(index)),
    'com.vervaintech.roomdatabase.database.jsIsNull' : (stmt, index) => stmt.get(index) === null,
    'com.vervaintech.roomdatabase.database.jsColumnCount' : (stmt) => stmt.columnCount,
    'com.vervaintech.roomdatabase.database.jsColumnName' : (stmt, index) => stmt.getColumnName(index),
    'com.vervaintech.roomdatabase.database.jsStmtStep' : (stmt) => stmt.step(),
    'com.vervaintech.roomdatabase.database.jsStmtReset' : (stmt) => { stmt.reset() },
    'com.vervaintech.roomdatabase.database.jsStmtFinalize' : (stmt) => { stmt.finalize() },
    'com.vervaintech.core.notifications.notificationApiAvailable' : () => (typeof Notification !== 'undefined'),
    'com.vervaintech.core.notifications.notificationPermissionGranted' : () => (typeof Notification !== 'undefined' && Notification.permission === 'granted'),
    'com.vervaintech.core.notifications.requestNotificationPermission' : () => Notification.requestPermission(),
    'com.vervaintech.core.notifications.dedup.jsNowMillis' : () => Date.now(),
    'com.vervaintech.core.share.shareViaWebShareApi' : (title, text) => 
        {
            if (navigator && navigator.share) {
                navigator.share({ title: title, text: text }).catch(function() {});
                return 1;
            }
            if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).catch(function() {});
                return 2;
            }
            return 0;
        }
        ,
    'com.vervaintech.core.media.triggerPngDownload' : (base64, fileName) => 
        {
            try {
                var a = document.createElement('a');
                a.href = 'data:image/png;base64,' + base64;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                return true;
            } catch (e) {
                return false;
            }
        }
        ,
    'com.vervaintech.core.launcher.encode' : (value) => encodeURIComponent(value),
    'com.vervaintech.geo.database.jsInitSqlite3' : () => import('@sqlite.org/sqlite-wasm').then(function(m){ return m.default(); }),
    'com.vervaintech.geo.database.jsOpenMemoryDb' : (sqlite3) => new sqlite3.oo1.DB(),
    'com.vervaintech.geo.database.jsDeserializeBase64' : (sqlite3, db, base64) => 
        (function () {
            try {
                var binary = atob(base64);
                var len = binary.length;
                var bytes = new Uint8Array(len);
                for (var i = 0; i < len; i++) { bytes[i] = binary.charCodeAt(i); }
                var p = sqlite3.wasm.allocFromTypedArray(bytes);
                var rc = sqlite3.capi.sqlite3_deserialize(
                    db.pointer, 'main', p, len, len,
                    sqlite3.capi.SQLITE_DESERIALIZE_FREEONCLOSE | sqlite3.capi.SQLITE_DESERIALIZE_RESIZEABLE);
                return rc === 0;
            } catch (e) { console.error('geo deserialize failed: ' + e); return false; }
        })()
        ,
    'com.vervaintech.geo.database.jsDbInTransaction' : (sqlite3, db) => sqlite3.capi.sqlite3_get_autocommit(db.pointer) === 0,
    'com.vervaintech.geo.database.jsConsoleError' : (message) => { console.error(message) },
    'com.vervaintech.geo.database.jsDbPrepare' : (db, sql) => db.prepare(sql),
    'com.vervaintech.geo.database.jsDbClose' : (db) => { db.close() },
    'com.vervaintech.geo.database.jsBindDouble' : (stmt, index, value) => { stmt.bind(index, value) },
    'com.vervaintech.geo.database.jsBindText' : (stmt, index, value) => { stmt.bind(index, value) },
    'com.vervaintech.geo.database.jsBindNull' : (stmt, index) => { stmt.bind(index, null) },
    'com.vervaintech.geo.database.jsGetDouble' : (stmt, index) => Number(stmt.get(index)),
    'com.vervaintech.geo.database.jsGetText' : (stmt, index) => String(stmt.get(index)),
    'com.vervaintech.geo.database.jsIsNull' : (stmt, index) => stmt.get(index) === null,
    'com.vervaintech.geo.database.jsColumnCount' : (stmt) => stmt.columnCount,
    'com.vervaintech.geo.database.jsColumnName' : (stmt, index) => stmt.getColumnName(index),
    'com.vervaintech.geo.database.jsStmtStep' : (stmt) => stmt.step(),
    'com.vervaintech.geo.database.jsStmtReset' : (stmt) => { stmt.reset() },
    'com.vervaintech.geo.database.jsStmtFinalize' : (stmt) => { stmt.finalize() },
    'com.vervaintech.qr.ui.jsScannerSupported' : () => (
            typeof navigator !== 'undefined' &&
            !!navigator.mediaDevices &&
            !!navigator.mediaDevices.getUserMedia &&
            typeof BarcodeDetector !== 'undefined'
        ),
    'com.vervaintech.qr.ui.jsStartScanner' : (onCode, onStatus) => 
        (function () {
            var state = { stream: null, stopped: false, video: null, timer: null, last: null };
            var video = document.createElement('video');
            video.setAttribute('playsinline', '');
            video.muted = true;
            video.style.position = 'fixed';
            video.style.visibility = 'hidden';
            video.style.objectFit = 'cover';
            video.style.borderRadius = '24px';
            video.style.pointerEvents = 'none';
            video.style.zIndex = '2147483647';
            state.video = video;

            var detector = new BarcodeDetector({ formats: ['qr_code'] });

            navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } }).then(function (stream) {
                if (state.stopped) {
                    stream.getTracks().forEach(function (t) { t.stop(); });
                    return;
                }
                state.stream = stream;
                video.srcObject = stream;
                document.body.appendChild(video);
                var p = video.play();
                if (p && p.catch) { p.catch(function () {}); }
                onStatus('GRANTED');
                state.timer = setInterval(function () {
                    if (state.stopped) return;
                    detector.detect(video).then(function (codes) {
                        if (state.stopped || !codes || codes.length === 0) return;
                        var value = codes[0].rawValue;
                        if (value && value !== state.last) {
                            state.last = value;
                            onCode(value);
                        }
                    }).catch(function () {});
                }, 400);
            }).catch(function (err) {
                var name = (err && err.name) ? err.name : '';
                if (name === 'NotAllowedError' || name === 'SecurityError') {
                    onStatus('PERMANENTLY_DENIED');
                } else {
                    onStatus('UNSUPPORTED');
                }
            });

            return state;
        })()
        ,
    'com.vervaintech.qr.ui.jsStopScanner' : (handle) => { 
            (function () {
                var state = handle;
                if (!state) return;
                state.stopped = true;
                if (state.timer) { clearInterval(state.timer); state.timer = null; }
                if (state.stream) {
                    state.stream.getTracks().forEach(function (t) { t.stop(); });
                    state.stream = null;
                }
                if (state.video && state.video.parentNode) {
                    state.video.parentNode.removeChild(state.video);
                }
            })()
             },
    'com.vervaintech.qr.ui.jsDevicePixelRatio' : () => (window.devicePixelRatio || 1),
    'com.vervaintech.qr.ui.jsUpdateScannerRect' : (handle, left, top, width, height) => { 
            (function () {
                var state = handle;
                if (!state || !state.video) return;
                var video = state.video;
                if (width < 1 || height < 1) {
                    video.style.visibility = 'hidden';
                    return;
                }
                video.style.left = left + 'px';
                video.style.top = top + 'px';
                video.style.width = width + 'px';
                video.style.height = height + 'px';
                video.style.transform = 'none';
                video.style.visibility = 'visible';
            })()
             },
    'com.vervaintech.firebase.firestore.web.api.jsDateNow' : () => Date.now(),
    'com.vervaintech.firebase.firestore.web.gateway.jsRandomUuid' : () => crypto.randomUUID(),
    'com.vervaintech.firebase.firestore.web.gateway.jsNowMillis' : () => Date.now(),
    'com.vervaintech.firebase.authentication.web.api.jsErrorCode' : (value) => (value && value.code) ? String(value.code) : null,
    'com.vervaintech.location.maps.jsSetMapHidden' : (id, hidden) => { 
            {
                // Re-show after the sheet's exit animation so the map never flashes
                // over a modal that is still sliding out.
                var REAPPEAR_MS = 320;
                [document.getElementById(id), document.getElementById(id + '-ov')].forEach(function (el) {
                    if (!el) return;
                    el.__pzHidden = hidden;
                    if (el.__pzShowTimer) { clearTimeout(el.__pzShowTimer); el.__pzShowTimer = null; }
                    if (hidden) { el.style.display = 'none'; return; }
                    el.__pzShowTimer = setTimeout(function () {
                        if (!el.__pzHidden && el.style.width) el.style.display = 'block';
                    }, REAPPEAR_MS);
                });
            }
             },
    'com.vervaintech.location.maps.jsEnsureMapFrame' : (id, latitude, longitude, label, address) => { 
            {
                if (!document.getElementById(id)) {
                    var frame = document.createElement('iframe');
                    frame.id = id;
                    frame.src = 'https://www.google.com/maps?q=' + latitude + ',' + longitude + '&z=15&output=embed';
                    // pointer-events:none — clicks fall through to the overlay below,
                    // which opens Google Maps (the embed must not capture pans).
                    frame.style.cssText = 'position:fixed;border:0;border-radius:16px;display:none;z-index:10;pointer-events:none;';
                    frame.setAttribute('loading', 'lazy');
                    frame.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
                    // Mount on <html>, not <body> — Compose owns <body> and collapses
                    // foreign body children to 0x0 (same reason the Stripe sheet mounts here).
                    document.documentElement.appendChild(frame);

                    var mapsUrl = 'https://www.google.com/maps/search/?api=1&query=' + latitude + ',' + longitude;

                    var ov = document.createElement('div');
                    ov.id = id + '-ov';
                    ov.style.cssText = 'position:fixed;display:none;z-index:11;cursor:pointer;border-radius:16px;overflow:hidden;font-family:system-ui,-apple-system,sans-serif;';
                    ov.onclick = function () { window.open(mapsUrl, '_blank', 'noopener'); };

                    // Shop-name info label (white, near top-centre) — mirrors the native
                    // marker info window.
                    var lbl = document.createElement('div');
                    lbl.style.cssText = 'position:absolute;top:12px;left:50%;transform:translateX(-50%);max-width:88%;background:#ffffff;border-radius:10px;padding:8px 14px;box-shadow:0 2px 10px rgba(0,0,0,.35);text-align:center;';
                    var nm = document.createElement('div');
                    nm.style.cssText = 'font-weight:700;font-size:14px;color:#111111;';
                    nm.textContent = label;
                    lbl.appendChild(nm);
                    if (address) {
                        var ad = document.createElement('div');
                        ad.style.cssText = 'font-size:12px;color:#444444;margin-top:2px;';
                        ad.textContent = address;
                        lbl.appendChild(ad);
                    }
                    ov.appendChild(lbl);

                    // Bottom address card — mirrors the Compose Location info-card.
                    var card = document.createElement('div');
                    card.style.cssText = 'position:absolute;left:12px;right:12px;bottom:12px;display:flex;align-items:center;gap:12px;background:rgba(18,28,28,.88);border-radius:16px;padding:10px 14px;';
                    var pin = document.createElement('div');
                    pin.style.cssText = 'flex:0 0 auto;width:38px;height:38px;border-radius:50%;background:rgba(122,223,211,.18);display:flex;align-items:center;justify-content:center;color:#7adfd3;font-size:18px;';
                    pin.textContent = '\u{1F4CD}';
                    var col = document.createElement('div');
                    col.style.cssText = 'flex:1 1 auto;min-width:0;';
                    var addrLine = document.createElement('div');
                    addrLine.style.cssText = 'color:#eef2f2;font-size:13px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;';
                    addrLine.textContent = address;
                    var sub = document.createElement('div');
                    sub.style.cssText = 'color:#9bb2b0;font-size:11px;letter-spacing:.5px;margin-top:1px;';
                    sub.textContent = 'LOCATION';
                    col.appendChild(addrLine);
                    col.appendChild(sub);
                    var dir = document.createElement('div');
                    dir.style.cssText = 'flex:0 0 auto;width:38px;height:38px;border-radius:50%;background:rgba(255,255,255,.10);display:flex;align-items:center;justify-content:center;color:#cfe0de;font-size:16px;';
                    dir.textContent = '\u{27A4}';
                    card.appendChild(pin);
                    card.appendChild(col);
                    card.appendChild(dir);
                    ov.appendChild(card);

                    document.documentElement.appendChild(ov);
                }
            }
             },
    'com.vervaintech.location.maps.jsRemoveMapFrame' : (id) => { 
            {
                var frame = document.getElementById(id);
                if (frame) frame.remove();
                var ov = document.getElementById(id + '-ov');
                if (ov) ov.remove();
            }
             },
    'com.vervaintech.location.maps.jsPositionMapFrame' : (id, left, top, width, height) => { 
            {
                // The map is a fixed-position overlay above the Compose canvas, so it would
                // otherwise paint OVER the floating bottom navigation bar (which Compose draws
                // on the canvas) when the card scrolls down near it. Clamp the visible height
                // so neither the iframe nor the overlay enters the reserved bottom strip the
                // nav floats in. Likewise clip the top so it doesn't cover a top bar.
                var reservedBottom = 96;
                var reservedTop = 0;
                var vh = window.innerHeight;
                var maxBottom = vh - reservedBottom;
                // Crop (not resize) the strips that would overlap the top/bottom bars, so
                // the map keeps its true size and the bottom nav stays visible above it.
                var topInset = Math.max(0, reservedTop - top);
                var bottomInset = Math.max(0, (top + height) - maxBottom);

                // Hide the map WHILE actively scrolling and fade it back in once scroll
                // settles. onGloballyPositioned fires every frame during a scroll, so each
                // call drops opacity to 0 and (re)arms a settle timer that fades it back to
                // 1 when the repositions stop. This removes the cropped-strip / chase jitter
                // of a fixed element tracking a scrolling canvas — at rest the map is crisp.
                var SETTLE_MS = 160;
                var apply = function (el, clickable) {
                    if (!el) return;
                    if (el.__pzHidden || topInset + bottomInset >= height) { el.style.display = 'none'; return; }
                    el.style.display = 'block';
                    el.style.left = left + 'px';
                    el.style.top = top + 'px';
                    el.style.width = width + 'px';
                    el.style.height = height + 'px';
                    el.style.clipPath = 'inset(' + topInset + 'px 0px ' + bottomInset + 'px 0px round 16px)';
                    el.style.transition = 'opacity .22s ease';
                    el.style.opacity = '0';
                    if (clickable) el.style.pointerEvents = 'none';
                    if (el.__pzTimer) clearTimeout(el.__pzTimer);
                    el.__pzTimer = setTimeout(function () {
                        el.style.opacity = '1';
                        if (clickable) el.style.pointerEvents = 'auto';
                    }, SETTLE_MS);
                };
                apply(document.getElementById(id), false);
                apply(document.getElementById(id + '-ov'), true);
            }
             },
    'com.vervaintech.kmpapp.applicationlayer.jsSessionStorageSet' : (key, value) => (function () { try { if (value == null) sessionStorage.removeItem(key); else sessionStorage.setItem(key, value); } catch (_) {} })(),
    'com.vervaintech.kmpapp.applicationlayer.jsSessionStorageGet' : (key) => (function () { try { return sessionStorage.getItem(key); } catch (_) { return null; } })(),
    'com.vervaintech.kmpapp.applicationlayer.jsClearKeyboardDismissedHandler' : () => (function () { window.prompzyKeyboardDismissed = undefined; })(),
    'com.vervaintech.kmpapp.applicationlayer.jsSetKeyboardDismissedHandler' : (handler) => (function () { window.prompzyKeyboardDismissed = handler; })(),
    'com.vervaintech.kmpapp.applicationlayer.clipboard.jsCopyRichText' : (html, plainText) => 
        {
            if (!navigator.clipboard || typeof ClipboardItem === 'undefined') return Promise.resolve(false);
            var item = new ClipboardItem({
                'text/html': new Blob([html], { type: 'text/html' }),
                'text/plain': new Blob([plainText], { type: 'text/plain' })
            });
            return navigator.clipboard.write([item]).then(function () { return true; }).catch(function (error) {
                console.warn('Rich-text copy refused: ' + (error && error.message));
                return false;
            });
        }
        ,
    'com.vervaintech.kmpapp.applicationlayer.utils.jsBrowserLanguage' : () => (navigator.language || null),
    'com.vervaintech.kmpapp.applicationlayer.utils.jsStoredLanguage' : (key) => { try { return window.localStorage.getItem(key); } catch (e) { return null; } },
    'com.vervaintech.kmpapp.applicationlayer.utils.jsStoreLanguage' : (key, code) => {
            try {
                if (code === null) window.localStorage.removeItem(key);
                else window.localStorage.setItem(key, code);
                return true;
            } catch (e) { return false; }
        },
    'com.vervaintech.kmpapp.applicationlayer.utils.jsReload' : () => window.location.reload(),
    'com.vervaintech.kmpapp.applicationlayer.utils.jsRegionDisplayName' : () => {
            try {
                var lang = navigator.language || '';
                var parts = lang.split('-');
                var region = parts.length > 1 ? parts[parts.length - 1] : null;
                if (!region) return null;
                var names = new Intl.DisplayNames(['en'], { type: 'region' });
                return names.of(region) || null;
            } catch (e) { return null; }
        },
    'com.vervaintech.kmpapp.applicationlayer.utils.jsAssignLocation' : (url) => window.location.assign(url),
    'com.vervaintech.kmpapp.jsShowStartupError' : (message) => 
        {
            var box = document.getElementById('app-error');
            if (box) {
                box.textContent = '';
                var hd = document.createElement('div');
                hd.className = 'hd';
                hd.textContent = 'Prompzy failed to start';
                box.appendChild(hd);
                box.appendChild(document.createTextNode(message));
                box.className = 'show';
            }
        }

}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        memory: new WebAssembly.Memory({ initial: 0 }),
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    